/**
 * Türkçe / İngilizce ondalık metnini sayıya çevirir.
 * "10,5" → 10.5 | "10.5" → 10.5 | "1.234,56" → 1234.56 | "1,234.56" → 1234.56
 * Geçmiş DB kayıtlarına dokunmaz; yalnızca UI parse içindir.
 */
export function parseTrNumber(value: string | undefined | null): number {
  if (value == null) return NaN;
  let s = String(value).trim().replace(/\s/g, '').replace(/[^\d.,-]/g, '');
  if (!s || s === '-' || s === '.' || s === ',') return NaN;

  const neg = s.startsWith('-');
  if (neg) s = s.slice(1);

  const lastComma = s.lastIndexOf(',');
  const lastDot = s.lastIndexOf('.');

  if (lastComma >= 0 && lastDot >= 0) {
    if (lastComma > lastDot) {
      // 1.234,56
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      // 1,234.56
      s = s.replace(/,/g, '');
    }
  } else if (lastComma >= 0) {
    const parts = s.split(',');
    if (parts.length === 2) {
      // Tek virgül → ondalık (TR): 10,5
      s = `${parts[0].replace(/\./g, '')}.${parts[1]}`;
    } else {
      // Birden fazla virgül → binlik
      s = parts.join('');
    }
  } else if (lastDot >= 0) {
    const parts = s.split('.');
    if (parts.length > 2) {
      // 1.234.567 → binlik
      s = parts.join('');
    }
    // Tek nokta: ondalık (10.5) — olduğu gibi bırak
  }

  const n = Number((neg ? '-' : '') + s);
  return Number.isFinite(n) ? n : NaN;
}

/** Ant Design InputNumber parser — her zaman number (boşsa NaN). */
export function parseTrInputNumber(value: string | undefined): number {
  if (value == null || String(value).trim() === '') return Number.NaN;
  const n = parseTrNumber(value);
  return Number.isFinite(n) ? n : Number.NaN;
}

/**
 * Sayıyı TR gösterimine çevirir: binlik `.`, ondalık `,`
 * Ant Design formatter için (value genelde string/number).
 */
export function formatTrInputNumber(
  value: string | number | undefined,
  info?: { userTyping?: boolean; input?: string }
): string {
  if (value === undefined || value === null || value === '') return '';
  if (typeof value === 'number' && Number.isNaN(value)) return '';

  // Kullanıcı yazarken sondaki ayırıcıyı koru
  if (info?.userTyping && info.input != null && /[.,]$/.test(info.input)) {
    return info.input;
  }

  const raw = String(value);
  if (!raw || raw === 'NaN') return '';

  const neg = raw.startsWith('-');
  const body = neg ? raw.slice(1) : raw;
  const [intPart, decPart] = body.split('.');
  const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const formatted = decPart != null && decPart !== '' ? `${withThousands},${decPart}` : withThousands;
  return neg ? `-${formatted}` : formatted;
}

export const TR_DECIMAL_SEPARATOR = ',';
